<template lang="pug">
div.x-pagelet-text.px-5
  markdown-viewer {{ content }}
</template>

<style scoped>
.x-pagelet-text {
  overflow-x: scroll;
  overflow-y: hide;
}
</style>

<script>
import MarkdownViewer from '@/components/commons/markdown-viewer/MarkdownViewer'

export default {

  components: {
    MarkdownViewer,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    // @type {Keep.Paper.Design.Entity}
    pagelet: Object,
  },

  computed: {
    content: vm => vm.pagelet?.value,
  },
}
</script>